import {
  PushHistoryStackEntryAction,
  createPushHistoryStackEntryActionCreator,
} from '../history-stack';
import { ADMIN_MODALS_HISTORY_ACTION_TYPE_PREFIX } from './constants';
import { AdminModalName } from '../../state';
import { AdminModalsActionType } from './admin-modals-action-type';

export type PushAdminModal = PushHistoryStackEntryAction<
  AdminModalsActionType.Push
>;

export const pushAdminModal = createPushHistoryStackEntryActionCreator<
  AdminModalsActionType.Push,
  AdminModalName,
  any
>(ADMIN_MODALS_HISTORY_ACTION_TYPE_PREFIX);
